// 判断缓存页面的数据
export const cachePage=(to:any,from:any)=>{
    // 申请列表
    if(to.path=='/openlist'){
      if(from.path=='/signsure/detail'){
        to.meta.flag=true
      }else{
        to.meta.flag=false
      } 
    }
    // 流程列表
    if(to.path=='/processlist'){
      if(from.path.includes('/process')){
        to.meta.flag=true
      }else{
        to.meta.flag=false
      } 
    }
    // 工商变更
    if(to.path=='/changelist'){
      if(from.path=='/changeProcess'){
        to.meta.flag=true
      }else{
        to.meta.flag=false
      } 
    }
    // 待审批、已审批、我发起的、抄送我的
    if(to.path=='/signsure'||to.path=='/signconting'||to.path=='/signlaunch'||to.path=='/signcopy'){
      if(from.path=='/signsure/detail'){
        to.meta.flag=true
      }else{
        to.meta.flag=false
      } 
    }
   
} 